import { ManualResultsFormPopup } from "@/Common/Components/ManualLabResultsEntry/ManualResultsFormPopup";
import { NotesToolTipControl } from "@/Common/Components/Modals/NotesToolTipControl";
import { Patient } from "@/Common/Models/Patient/Patient";
import { Person } from "@/Common/Models/Person/Person";
import { LabTabViews } from "@/Common/Models/UI/Enums";
import * as LocalOperations from "@/Common/Operations/operations.local";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { LabActionDetailsPopup } from "@/Labs/Components/LabActionDetailsPopup";
import { LabActionDetailsTooltipControl } from "@/Labs/Components/LabActionDetailsTooltipControl";
import { LabActionNotesTooltipControl } from "@/Labs/Components/LabActionNotesTooltipControl";
import { LabGraphSearchComponent } from "@/Labs/Components/LabGraphSearchComponent";
import { LabsActionInboxView } from "@/Labs/Components/LabsActionInboxView";
import { LabsTabState } from "@/Labs/Components/LabsTab";
import { LabTreeControl } from "@/Labs/Components/LabTreeControl";
import { PatientLabGraphView } from "./PatientLabGraphView";
import { PatientLabsInboxView } from "./PatientLabsInboxView";
import { PatientLabView } from "./PatientLabView";

interface IPatientLabs {
    patientId: string;
    patient: Patient;
    isReadOnly?: boolean;
    onCloseManualEntryPopup?: () => void;
}

class PatientLabsTab extends React.Component<IPatientLabs, LabsTabState> {
    private changeListenerMethodId: string;
    private ramqChangeListenerMethodId: string;

    public render(): JSX.Element {
        return (
            <div data-cy="patient-labsTab" className="inner-container inherit-height">
                <div className="tb patient-docs embedded inherit-height">
                    {this.renderLeftSideTreeMenuOrNot(this.state.Model.get("CurrentView"))}

                    {this.state.Model.get("CurrentView") === LabTabViews.Graph && (
                        <div className="left-nav-menu lab-graphs" style={{ width: "200px" }}>
                            <div className="fxheight">
                                <div>
                                    <a onClick={() => { LocalEvent.Dispatch(LocalOperations.LabsUI.Graphs_BackToResults); }}>  {"<< " + cacheStore.GetString("BackToResultLabel")}</a>
                                </div>
                                <LabGraphSearchComponent LabModel={this.state.LabModel} GraphModel={this.state.LabGraphModel} />
                            </div>
                        </div>
                    )}

                    {this.state.Model.get("CurrentView") == LabTabViews.Inbox &&
                        <PatientLabsInboxView Model={this.state.LabsInboxModel} PatientModel={this.props.patient} PatientContactId={this.props.patientId} IsDSQActive={patientStore.isDSQActive()} isReadOnly={this.props.isReadOnly} />
                    }
                    {this.state.Model.get("CurrentView") == LabTabViews.Lab && this.state.LabModel != null &&
                        <PatientLabView Model={this.state.LabModel} InboxModel={this.state.LabsInboxModel} SideNoteModel={this.state.SiteNoteModel} LabTabModel={this.state.Model} isReadOnly={this.props.isReadOnly} />
                    }
                    {this.state.Model.get("CurrentView") == LabTabViews.ActionsInbox &&
                        <LabsActionInboxView Model={this.state.LabsActionInboxModel} />
                    }
                    {this.state.Model.get("CurrentView") == LabTabViews.Graph &&
                        <PatientLabGraphView LabModel={this.state.LabModel} GraphModel={this.state.LabGraphModel} />
                    }

                    {this.state.Model.get("NoteWindowOpen") == true && (
                        <NotesToolTipControl
                            ControlId="lab_notes_dropdown_main"
                            notes={this.state.Model.get("CurrentLabNotes").toArray()}
                            ReferenceId={this.state.Model.get("CurrentLabIDForNotes")}
                            SubReferenceId={this.state.Model.get("CurrentElementIDForNotes")}
                            Value={this.state.Model.get("CurrentLabNoteValue")}
                            EventToDispatchOnSave={LocalOperations.LabsUI.Note_Save}
                            EventToDispatchOnTextChanged={LocalOperations.LabsUI.Note_Text_Changed}
                            EventToDispatchOnDropdownClosed={LocalOperations.LabsUI.ClosePopups}
                            leftPosition={this.state.Model.get("NoteLeftPosition")}
                            topPosition={this.state.Model.get("NoteTopPosition")}
                        />
                    )}

                    {this.state.Model.get("Action_NoteWindowOpen") == true && (
                        <LabActionNotesTooltipControl
                            ControlId="lab_actions_dropdown_main"
                            ReferenceId={this.state.Model.get("Action_CurrentLabIDForNotes")}
                            SubReferenceId={this.state.Model.get("Action_CurrentElementIDForNotes")}
                            Value={this.state.Model.get("Action_CurrentLabNoteValue")}
                            actionNursesCheckboxes={this.state.Model.get("Action_CheckboxesNurses")}
                            actionSecretaryCheckboxes={this.state.Model.get("Action_CheckboxesSecretaries")}
                            leftPosition={this.state.Model.get("Action_NoteLeftPosition")}
                            topPosition={this.state.Model.get("Action_NoteTopPosition")}
                            EventToDispatchToClosePopup={LocalOperations.LabsUI.ClosePopups}
                        />
                    )}

                    {this.state.Model.get("Action_DetailsWindowOpen") == true && (
                        <LabActionDetailsTooltipControl
                            ControlId="lab_actionsdetails_dropdown_main"
                            Model={this.state.Model.get("Action_DetailsModel")}
                            ReferenceId={this.state.Model.get("Action_CurrentLabIDForActionDetails")}
                            leftPosition={this.state.Model.get("Action_DetailsLeftPosition")}
                            topPosition={this.state.Model.get("Action_DetailsTopPosition")}
                            EventToDispatchToClosePopup={LocalOperations.LabsUI.ClosePopups}
                        />
                    )}

                    {cacheStore.ClinicSettings.EnableResultsFixes &&
                        this.state.Model.get("ResultDetailPopupOpen") === true &&
                        (
                            <LabActionDetailsPopup
                                notes={this.state.Model.get("CurrentLabNotes").toArray()}
                                noteTextValue={this.state.Model.get("CurrentLabNoteValue")}
                                detailTextValue={this.state.Model.get("CurrentLabDetailsValue")}
                                referenceId={this.state.Model.get("CurrentLabIDForNotes")}
                                subReferenceId={this.state.Model.get("CurrentElementIDForNotes")}
                                onNoteTextChange={(newText: string): void => {
                                    sessionStore.dispatch(LocalOperations.LabsUI.Note_Text_Changed, {
                                        value: newText
                                    });
                                }}
                                onClose={(): void => sessionStore.dispatch(LocalOperations.LabsUI.ClosePopups)}
                                isManualLabEntry={this.state.Model.get("CurrentLabIsManualResult")}
                            />
                        )
                    }

                    {(this.state.Model.get("IsManualResultsFormPopupOpen")) && (
                        <ManualResultsFormPopup
                            currentPatient={Person.FromIndividual(this.props.patient.IndividualResponse)}
                            onClose={(): void => {
                                this.props.onCloseManualEntryPopup?.();
                                sessionStore.dispatch(LocalOperations.LabsUI.CloseManualEntryFormPopup);
                            }}
                        />
                    )}
                </div>
            </div>
        );
    }

    private renderLeftSideTreeMenuOrNot(view: LabTabViews): JSX.Element {
        if (view !== LabTabViews.Graph) {
            return (
                <div className="left-nav-menu labs transition">
                    <div className="ws-scrollable hide-overflow" style={{ "height": "100%" }}>
                        <LabTreeControl IsPatientNav={true} CurrentView={this.state.Model.get("CurrentView")} Model={this.state.Model} NonApprovedLabCount={null} CurrentActionInbox={labsStore.LabsActionInboxModel.get("CurrentInbox")} CurrentLabInbox={labsStore.LabsInboxModel.get("CurrentInbox")} />
                    </div>
                </div>
            );
        }
        else {
            return (<div className="left-nav-menu labs collapsed" />);
        }
    }

    public componentWillMount(): void {
        labsStore.SaveState(); // just in case we come from LabsTab (componentWillUnmount of LabsTab is called after componentWillMount here)
        this.ResetPatientLabsModel(this.props.patientId);
    }

    public componentWillReceiveProps(nextProps: IPatientLabs): void {
        if (this.props.patientId != nextProps.patientId) {
            this.ResetPatientLabsModel(nextProps.patientId);
            labsStore.Model = labsStore.Model.set("PatientContactId", nextProps.patientId);
            labsStore.RefreshSearch();
        }
    }

    public ResetPatientLabsModel(patientContactId: string): void {
        labsStore.ImportLabsModels(patientStore.PatientLabs[patientContactId]);
        labsStore.LoadSettings(true);
        if (!labsStore.Model.get("Action_MedicalItemDetails"))
            labsStore.Model = labsStore.Model.set("CurrentView", LabTabViews.Inbox);
        this.changeListener();
    }

    public shouldComponentUpdate(nextProps: any, nextState: LabsTabState): boolean {
        return (
            this.state.Model !== nextState.Model
            || this.state.LabsInboxModel !== nextState.LabsInboxModel
            || this.state.LabModel !== nextState.LabModel
            || this.state.SiteNoteModel !== nextState.SiteNoteModel
            || this.state.LabsActionInboxModel !== nextState.LabsActionInboxModel
            || this.state.LabGraphModel !== nextState.LabGraphModel
        );
    }

    public componentDidMount(): void {
        this.changeListenerMethodId = labsStore.AddChangeListener(this.changeListener, this, "lab-tab-listener");
        this.ramqChangeListenerMethodId = ramqStore.AddChangeListener(this.ramqChangeListener, this, "lab-tab-ramqlistener");
        labsStore.Model = labsStore.Model.set("PatientContactId", this.props.patientId);
        labsStore.RefreshSearch();
    }

    public componentWillUnmount(): void {
        labsStore.SaveState();
        labsStore.Model = labsStore.Model.set("PatientContactId", "");
        labsStore.RemoveChangeListener(this.changeListenerMethodId);
        ramqStore.RemoveChangeListener(this.ramqChangeListenerMethodId);
    }

    public changeListener(): void {
        var s = new LabsTabState();
        s.Model = labsStore.Model;
        s.LabsInboxModel = labsStore.LabsInboxModel;
        s.LabModel = labsStore.LabModel;
        s.SiteNoteModel = labsStore.SideNoteModel;
        s.LabsActionInboxModel = labsStore.LabsActionInboxModel;
        s.LabGraphModel = labsStore.LabGraphModel;
        this.setState(s);
    }

    public ramqChangeListener(): void {
        if (labsStore.LabModel) {
            var patientModel = labsStore.LabModel.get("MylePatient");
            labsStore.LabModel = labsStore.LabModel.delete("MylePatient");
            labsStore.LabModel = labsStore.LabModel.set("MylePatient", patientModel);
        }
    }
}

export { PatientLabsTab };
